import { useEffect, useState } from "react";
import { getGroupsByUserId } from "../services/groupService";

interface IUseFetchGroupsByUserId {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  userId: string | number | null | undefined;
}

const useFetchGroupsByUserId = ({
  setIsLoading,
  userId,
}: IUseFetchGroupsByUserId) => {
  const [assignedGroups, setAssignedGroups] = useState<any[]>([]);

  useEffect(() => {
    if (!userId) {
      setAssignedGroups([]);
      return;
    }

    const fetchAssignedGroups = async () => {
      setIsLoading(true);
      try {
        const response = await getGroupsByUserId(userId);
        console.log("Assigned groups response:", response);
        setAssignedGroups(response || []);
      } catch (err) {
        console.error("Error fetching assigned groups:", err);
        setAssignedGroups([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssignedGroups();
  }, [userId, setIsLoading]);

  return [assignedGroups, setAssignedGroups] as const;
};

export default useFetchGroupsByUserId;
